export const CACHE_KEY_USER_CONFIG = 'userConfig';
export const CACHE_KEY_USER_INFO = 'userInfo';
export const CACHE_KEY_PC_USER_CONFIG = 'pcUserConfig';
export const CACHE_KEY_PC_USER_INFO = 'pcUserInfo';
